import { connect } from 'react-redux';
import Outline from './outline';

const mapStateToProps = state => ({
  outline: state.outline,
});

export default connect(mapStateToProps)(Outline);
